import { PaymentMethodsGenericActionsProps } from '../../../components/payment-methods/actions/actions-generic';
import { GatewaySwitch } from '../../../components/switches/gateway-switch';
import { usePaymentMethodsJustifiContext } from '../context/payment-methods-justifi.context';
import { usePaymentMethodsStripeContext } from '../context/payment-methods-stripe.context';

export type PaymentMethodsContextToListActionsProps = {
  stripeComponent: React.FC<PaymentMethodsGenericActionsProps>;
  justifiComponent: React.FC<PaymentMethodsGenericActionsProps>;
  shouldUsePadding?: boolean;
};
export const PaymentMethodsContextToListActions = ({
  stripeComponent: StripeComponent,
  justifiComponent: JustifiComponent,
  shouldUsePadding,
}: PaymentMethodsContextToListActionsProps) => {
  return (
    <GatewaySwitch
      stripeContent={StripeActionsWithContext}
      stripeProps={{ render: StripeComponent, shouldUsePadding }}
      justifiContent={JustifiActionsWithContext}
      justifiProps={{ render: JustifiComponent, shouldUsePadding }}
    />
  );
};

const StripeActionsWithContext = ({
  render: RenderStripeComponent,
  shouldUsePadding,
}: {
  render: React.FC<PaymentMethodsGenericActionsProps>;
  shouldUsePadding?: boolean;
}) => {
  const { shouldShowFooter, listPrimary, listSecondary } = usePaymentMethodsStripeContext();

  return (
    <RenderStripeComponent
      shouldUsePadding={shouldUsePadding}
      primary={listPrimary}
      secondary={listSecondary}
      shouldShow={shouldShowFooter}
    />
  );
};

const JustifiActionsWithContext = ({
  render: RenderJustifiComponent,
  shouldUsePadding,
}: {
  render: React.FC<PaymentMethodsGenericActionsProps>;
  shouldUsePadding?: boolean;
}) => {
  const { shouldShowFooter, listPrimary, listSecondary } = usePaymentMethodsJustifiContext();

  return (
    <RenderJustifiComponent
      shouldUsePadding={shouldUsePadding}
      primary={listPrimary}
      secondary={listSecondary}
      shouldShow={shouldShowFooter}
    />
  );
};
